var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component } from 'vue-property-decorator';
import store from '@/store/index';
import { userLogout } from '@views/login/api/auth';
import EditUserInfoModal from './EditUserInfoModal.vue';
import CompanyChangeModal from './CompanyChangeModal.vue';
import { postUserUpdate } from 'src/common/api/common';
// import { getBooths } from 'src/views/businessOpportunity/api/index';
import { getAllCompanyList } from '@/views/company/api/index';
import eventLib from '@/common/utils/document-event';
import { getCookie, getStorage } from '@lhb/cache';
var UserInfoPopover = /** @class */ (function (_super) {
    __extends(UserInfoPopover, _super);
    function UserInfoPopover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /* data */
        _this.isEditName = false; // 是否正在编辑名称
        _this.userName = null; // 用户名称
        _this.showPopover = false;
        return _this;
    }
    Object.defineProperty(UserInfoPopover.prototype, "stateCommon", {
        /* computed */
        get: function () {
            return store.state.common || {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserInfoPopover.prototype, "user", {
        get: function () {
            return this.stateCommon.user || {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserInfoPopover.prototype, "enterpriseList", {
        get: function () {
            return this.$store.state.common.companies || [];
        },
        enumerable: false,
        configurable: true
    });
    UserInfoPopover.prototype.mounted = function () {
        var _this = this;
        this.$nextTick(function () {
            if ((getCookie('newPmsToken') || getStorage('newPmsToken')) && !_this.enterpriseList.length) {
                getAllCompanyList().then(function (data) {
                    _this.$store.commit('UPDATE_COMPANIES', data);
                });
            }
        });
    };
    /* methods */
    UserInfoPopover.prototype.init = function () {
        this.isEditName = false;
        this.userName = this.user.name;
    };
    UserInfoPopover.prototype.editName = function () {
        var _this = this;
        this.isEditName = true;
        this.userName = this.user.name;
        this.$nextTick(function () {
            _this.$refs.editName.focus();
        });
    };
    // 编辑用户名
    UserInfoPopover.prototype.saveName = function () {
        var _this = this;
        this.isEditName = false;
        if (this.userName !== this.user.name) {
            if (!this.userName) {
                this.$message.warning('用户名不能为空！');
                return false;
            }
            postUserUpdate({ name: this.userName }).then(function () {
                _this.$store.commit('UPDATE_USER_NAME', _this.userName); // 更新用户名
                _this.$message.success('修改用户名成功');
            });
        }
    };
    // 完善信息
    UserInfoPopover.prototype.editInfo = function () {
        this.$refs.editUserInfoModal && this.$refs.editUserInfoModal.init();
    };
    UserInfoPopover.prototype.contactQrcode = function () {
        // window.$_EventLib.dispatch('clickContact', null);
        window.LHBbigdata.send({
            event_id: '380691eb-0def-4d48-92f8-202883546624',
            msg: {
                operation: '联系客服',
                enterprise_id: this.user.companyName,
                user_name: this.user.name,
                user_tel: this.user.mobile,
            },
        });
        eventLib.dispatch('OPEN_IM');
        // if (this.$route.path === '/lhb-micro-pms/brandBusiness') {
        //   eventLib.dispatch('contactIM', { contactIM: true });
        // }
        // this.$router.push({ path: '/lhb-micro-pms/brandBusiness?openIM=true' });
        // eventLib.dispatch('OPEN_MICROIM', `${this.url}/#/home?source=pms&token=${this.token}&consultation_type=6&timestamp=${Math.random()}&mode=pc`);
        this.showPopover = false;
    };
    UserInfoPopover.prototype.changeCompany = function () {
        this.$refs.companyChangeModal && this.$refs.companyChangeModal.init();
    };
    // 退出登录
    UserInfoPopover.prototype.logout = function () {
        userLogout().then(function () {
            window.$_EventLib.dispatch('LOGOUT', null);
        });
    };
    UserInfoPopover = __decorate([
        Component({
            components: {
                EditUserInfoModal: EditUserInfoModal,
                CompanyChangeModal: CompanyChangeModal
            },
        })
    ], UserInfoPopover);
    return UserInfoPopover;
}(Vue));
export default UserInfoPopover;
